// extracted by mini-css-extract-plugin
export default {"buttonHeader":"LoanConfigurationsTableHead_buttonHeader__0Po2f"};